import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import _ from "lodash";
import styled from "styled-components";
import { navigate } from "@reach/router";
import Collapse from "@material-ui/core/Collapse";
import useSettings from "../../../hooks/useSettings";
import labels from "../../../helpers/labels.json";
import SystemService from "../../../services/SystemService";
import CaseService from "../../../services/CaseService";
import useUser from "../../../hooks/useUser";

const drawerWidth = 273;
const collapsedDrawerWidth = 84;

const hasModuleAccess = (userObject, moduleKey) => {
  const value = userObject?.moduleAccess?.[moduleKey];
  if (value === null || value === undefined) return false;
  return value === 1 || value === true;
};

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    transition: "width 0.3s ease",
  },
  drawerCollapsed: {
    width: collapsedDrawerWidth,
    flexShrink: 0,
    transition: "width 0.3s ease",
  },
  drawerPaper: {
    width: drawerWidth,
    overflowX: "hidden",
    overflowY: "auto",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
    },
  },
  drawerPaperCollapsed: {
    width: collapsedDrawerWidth,
    transition: "width 0.3s ease",
    overflowX: "hidden",
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
    },
  },
  drawerContainer: {
    overflow: "auto",
    height: "100%",
    transition: "background-color 0.3s ease",
    "&::-webkit-scrollbar": {
      width: 3,
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "rgba(255,255,255,0.0)",
      borderRadius: 4,
      transition: "background 0.3s",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      background: "rgba(255,255,255,0.22)",
    },
    /* Firefox */
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(255,255,255,0.18) transparent",
  },
  iconContainer: {
    borderRadius: 8,
    transition: "all 0.3s ease",
  },
  iconContainerCollapsedActive: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: 42,
    backgroundColor: "#333d68",
    borderRadius: 8,
    "& img": {
      filter: "brightness(0) invert(1)",
    },
  },

  iconContainerCollapsedInactive: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: 42,
    backgroundColor: "transparent",
    borderRadius: 8,
    "& img": {
      filter: "none",
    },
  },
  inactiveListItem: {
    padding: "0px",
    paddingLeft: 42,
    height: 62,
    borderBottom: "solid 0.3px rgba(255, 255, 255, 0.12)",
    "& span": {
      transition: "250ms",
    },
    "&:hover": {
      "& span": {
        color: "#fff",
      },
    },
  },
  activeListItem: {
    padding: "0px",
    paddingLeft: 42,
    height: 62,
    borderBottom: "solid 0.3px rgba(255, 255, 255, 0.12)",
    "& span": {
      transition: "250ms",
    },
    "&:hover": {
      "& span": {
        color: "#fff",
      },
    },
  },
  nested: {
    margin: "0 0 15px 0",
    marginLeft: "50px",
    width: "200px !important",
    height: "38px",
    borderRadius: "5px",
    transition: "300ms",
    boxSizing: "borderbox",
    "& span": {
      transition: "250ms",
      fontSize: "14px",
    },
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.05)",
      borderLeft: "3px solid #fff",
      "& span": {
        color: "#fff",
      },
    },
  },
  nestedCollapsed: {
    margin: "0 0 8px 0",
    marginLeft: "0px",
    width: "100% !important",
    height: "38px",
    borderRadius: "5px",
    transition: "300ms",
    justifyContent: "center",
    boxSizing: "borderbox",
    "& span": {
      transition: "250ms",
      fontSize: "14px",
    },
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.05)",
      "& span": {
        color: "#fff",
      },
    },
  },
  inactiveNested: {
    backgroundColor: "transparent",
  },
  activeNested: {
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    borderLeft: "3px solid #fff",
  },
  activeNestedCollapsed: {
    backgroundColor: "rgba(255, 255, 255, 0.05)",
  },
}));

export default function Sidebar({
  selectedItem,
  selectedSubItem,
  showDrawer,
  setShowDrawer,
  visible = true, // false panna sidebar completely hide aagum (render aagave aagathu)
}) {
  const classes = useStyles();
  const { setting, setSetting, setCaseLifeCycleStatus, setSelectMenuItems } =
    useSettings();
  const { userObject } = useUser();

  // 'visible' false na sidebar-ah completely hide pannurom.
  // Idhu 'showDrawer' vera vela (collapse/expand) ku use aagudhu, so athai touch pannala.
  const shouldHide = visible === false;

  const isCollapsed = showDrawer;

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setShowDrawer(false);
  };

  const myTasksItems = [
    {
      icon: require("../../../assets/images/pendingInactive.svg"),
      inactive: require("../../../assets/images/pending.svg"),
      title: labels.pending_actions,
      path: "/dashboard/case-manager",
      hide: !hasModuleAccess(userObject, "pendingActions"),
    },
    {
      icon: require("../../../assets/images/invoice.svg"),
      inactive: require("../../../assets/images/invoiceInactive.svg"),
      title: labels.proforma_invoice,
      path: "/dashboard/case-manager/proforma-invoice",
      hide: !hasModuleAccess(userObject, "proformaInvoice"),
    },
    {
      icon: require("../../../assets/images/upload.svg"),
      inactive: require("../../../assets/images/uploadInactive.svg"),
      title: labels.upload,
      path: "/dashboard/case-manager/uploads",
      hide: !hasModuleAccess(userObject, "upload"),
    },
    {
      icon: require("../../../assets/images/tick.svg"),
      inactive: require("../../../assets/images/tickInactive.svg"),
      title: labels.verify,
      path: "/dashboard/case-manager/verify-parties",
      hide:
        setting?.partyVerificationMethod === "automatic" ||
        !hasModuleAccess(userObject, "verifyParties"),
    },
    {
      icon: require("../../../assets/images/upload.svg"),
      inactive: require("../../../assets/images/uploadInactive.svg"),
      title: "Bulk Notice",
      path: "/dashboard/case-manager/bulk-notice",
      hide: !hasModuleAccess(userObject, "bulkNotice"),
    },
    {
      icon: require("../../../assets/images/upload.svg"),
      inactive: require("../../../assets/images/uploadInactive.svg"),
      title: labels.document_reports,
      path: "/dashboard/case-manager/document-reports",
      hide: !hasModuleAccess(userObject, "documentReports"),
    },
  ];

  const casesItems = [
    {
      icon: require("../../../assets/images/negotiation-active.svg"),
      inactive: require("../../../assets/images/negotiation-inactive.svg"),
      title: labels.negotiation,
      path: "/dashboard/case-manager/negotiation",
      hide: !hasModuleAccess(userObject, "negotiation"),
    },
    {
      icon: require("../../../assets/images/mediation-active.svg"),
      inactive: require("../../../assets/images/mediation-inactive.svg"),
      title: labels.mediation,
      path: "/dashboard/case-manager/mediation",
      hide: !hasModuleAccess(userObject, "mediation"),
    },
    {
      icon: require("../../../assets/images/mediation-active.svg"),
      inactive: require("../../../assets/images/mediation-inactive.svg"),
      title: labels.arbitration,
      path: "/dashboard/case-manager/arbitration",
      hide: !hasModuleAccess(userObject, "arbitration"),
    },
    {
      icon: require("../../../assets/images/bulkUploads.svg"),
      inactive: require("../../../assets/images/bulkUploadsInactive.png"),
      title: labels.bulk_uploads,
      path: "/dashboard/case-manager/bulk-uploads",
      hide: !hasModuleAccess(userObject, "bulkUploads"),
    },
  ];

  const meetingsItems = [
    {
      icon: require("../../../assets/images/mediation-active.svg"),
      inactive: require("../../../assets/images/mediation-inactive.svg"),
      title: labels.generic_meeting,
      path: "/dashboard/case-manager/generic-meeting",
      hide: !hasModuleAccess(userObject, "meetings"),
    },
    {
      icon: require("../../../assets/images/mediation-active.svg"),
      inactive: require("../../../assets/images/mediation-inactive.svg"),
      title: labels.meeting_details,
      path: "/dashboard/case-manager/meeting-details",
      hide: !hasModuleAccess(userObject, "meetings"),
    },
    {
      icon: require("../../../assets/images/cases.svg"),
      inactive: require("../../../assets/images/casesInactive.svg"),
      title: labels.daily_casuse,
      path: "/dashboard/case-manager/daily-cause",
      hide: !hasModuleAccess(userObject, "meetings"),
    },
    {
      icon: require("../../../assets/images/mediation-active.svg"),
      inactive: require("../../../assets/images/mediation-inactive.svg"),
      title: labels.neutral_meeting,
      path: "/dashboard/case-manager/neutral-meeting-details",
      hide: !hasModuleAccess(userObject, "meetings"),
    },
  ];

  const sidebar_options = [
    {
      icon: require("../../../assets/images/hamMenu.svg"),
      inactive: require("../../../assets/images/hamMenuInactive.svg"),
      title: labels.my_tasks,
      path: "/dashboard/case-manager",
      listItems: myTasksItems,
      showSidebar: myTasksItems.some((li) => !li.hide),
    },
    {
      icon: require("../../../assets/images/cases.svg"),
      inactive: require("../../../assets/images/casesInactive.svg"),
      title: labels.cases,
      path: "/dashboard/case-manager/negotiation",
      listItems: casesItems,
      showSidebar: casesItems.some((li) => !li.hide),
    },
    {
      icon: require("../../../assets/images/my_parties.svg"),
      inactive: require("../../../assets/images/partiesInactive.svg"),
      title: labels.parties,
      path: "/dashboard/case-manager/parties",
      showSidebar: hasModuleAccess(userObject, "parties"),
    },
    {
      icon: require("../../../assets/images/my_parties.svg"),
      inactive: require("../../../assets/images/partiesInactive.svg"),
      title: labels.comms_manager,
      path: "/dashboard/case-manager/comms-manager",
      showSidebar: hasModuleAccess(userObject, "commsManager"),
    },
    {
      icon: require("../../../assets/images/profiles.svg"),
      inactive: require("../../../assets/images/profilesInactive.svg"),
      title: labels.profiles,
      path: "/dashboard/case-manager/profiles",
      showSidebar: hasModuleAccess(userObject, "profiles"),
    },
    {
      icon: require("../../../assets/images/payments.svg"),
      inactive: require("../../../assets/images/paymentsInactive.svg"),
      blueIcon: require("../../../assets/images/Payment History_active_Blue.svg"),
      title: labels.payments,
      path: "/dashboard/case-manager/payments",
      showSidebar: hasModuleAccess(userObject, "payments"),
    },
    {
      icon: require("../../../assets/images/cases.svg"),
      inactive: require("../../../assets/images/casesInactive.svg"),
      title: labels.meetings,
      path: "/dashboard/case-manager/generic-meeting",
      listItems: meetingsItems,
      showSidebar: hasModuleAccess(userObject, "meetings"),
    },
    {
      icon: require("../../../assets/images/userPlaceholder.svg"),
      inactive: require("../../../assets/images/userPlaceholder.svg"),
      blueIcon: require("../../../assets/images/userPlaceholder.svg"),
      title: labels.transcriber,
      path: "/dashboard/case-manager/transcriber",
      showSidebar: hasModuleAccess(userObject, "transcriber"),
    },
    {
      icon: require("../../../assets/images/home.svg"),
      inactive: require("../../../assets/images/homeInactive.svg"),
      blueIcon: require("../../../assets/images/Home_active_Blue.svg"),
      title: labels.mis_dashboard,
      path: "/dashboard/case-manager/mis-dashboard",
      showSidebar: hasModuleAccess(userObject, "misDashboard"),
    },
    {
      icon: require("../../../assets/images/home.svg"),
      inactive: require("../../../assets/images/homeInactive.svg"),
      blueIcon: require("../../../assets/images/Home_active_Blue.svg"),
      title: labels.excel_schema_map,
      path: "/dashboard/case-manager/field-mapping",
      showSidebar: hasModuleAccess(userObject, "fieldMapping"),
    },
    {
      icon: require("../../../assets/images/home.svg"),
      inactive: require("../../../assets/images/homeInactive.svg"),
      blueIcon: require("../../../assets/images/userPlaceholder.svg"),
      title: labels.management_tools,
      path: "/dashboard/case-manager/tools",
      showSidebar: hasModuleAccess(userObject, "managementTools"),
    },
    {
      icon: require("../../../assets/images/home.svg"),
      inactive: require("../../../assets/images/homeInactive.svg"),
      blueIcon: require("../../../assets/images/userPlaceholder.svg"),
      title: labels.final_approver,
      path: "/dashboard/case-manager/final-approver",
      showSidebar: hasModuleAccess(userObject, "finalApprover"),
    },
    {
      icon: require("../../../assets/images/cases.svg"),
      inactive: require("../../../assets/images/casesInactive.svg"),
      blueIcon: require("../../../assets/images/userPlaceholder.svg"),
      title: labels.esigner,
      path: "/dashboard/case-manager/esigner",
      showSidebar: hasModuleAccess(userObject, "esigner"),
    },
    {
      icon: require("../../../assets/images/cases.svg"),
      inactive: require("../../../assets/images/casesInactive.svg"),
      blueIcon: require("../../../assets/images/userPlaceholder.svg"),
      title: labels.notice_tracking,
      path: "/dashboard/case-manager/tracking",
      showSidebar: hasModuleAccess(userObject, "noticeTracking"),
    },
    {
      icon: require("../../../assets/images/cases.svg"),
      inactive: require("../../../assets/images/casesInactive.svg"),
      blueIcon: require("../../../assets/images/userPlaceholder.svg"),
      title: "Booking Dashboard",
      path: "/dashboard/case-manager/booking-dashboard",
      showSidebar:
        userObject?.hasBookingAccess ||
        hasModuleAccess(userObject, "hasBookingAccess")
          ? true
          : false,
    },
    {
      icon: require("../../../assets/images/config.png"),
      inactive: require("../../../assets/images/configInactive.png"),
      blueIcon: require("../../../assets/images/userPlaceholder.svg"),
      title: labels.pricing,
      path: "/dashboard/case-manager/pricing",
      showSidebar: hasModuleAccess(userObject, "pricing"),
    },
  ];

  useEffect(() => {
    async function getSystemConfig() {
      try {
        const response = await SystemService.getConfigAuth();
        const document_type_response = await CaseService.getDocumentTypes();
        if (document_type_response?.documentTypes?.length) {
          setSelectMenuItems(
            document_type_response?.documentTypes?.map((item) => ({
              category: item?.documentCategory,
              name: item?.documentType,
            })),
          );
        }
        if (response.systemConfig) {
          setSetting(response.systemConfig);
        }
        setCaseLifeCycleStatus(response?.caseLifeCycle);
      } catch (error) {
        throw error;
      }
    }
    getSystemConfig(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // visible=false na Drawer render aagave aagathu - sidebar completely hide
  if (shouldHide) {
    return null;
  }

  return (
    <Drawer
      open
      anchor={"left"}
      className={isCollapsed ? classes.drawerCollapsed : classes.drawer}
      onClose={toggleDrawer(false)}
      variant="permanent"
      classes={{
        paper: isCollapsed ? classes.drawerPaperCollapsed : classes.drawerPaper,
      }}
    >
      <Toolbar />
      <div
        className={classes.drawerContainer}
        style={{
          backgroundColor: isCollapsed ? "#ffffff" : "#293461",
        }}
      >
        <List>
          {sidebar_options
            .filter((item) => item.showSidebar !== false)
            .map((data, index) => (
              <React.Fragment key={index}>
                <ListItem
                  className={
                    data.title === selectedItem
                      ? classes.activeListItem
                      : classes.inactiveListItem
                  }
                  style={{
                    ...(data.hasOwnProperty("listItems")
                      ? { borderBottom: 0 }
                      : {}),
                    paddingLeft: isCollapsed ? 0 : 42,
                    justifyContent: isCollapsed ? "center" : "flex-start",
                  }}
                  button
                  onClick={() => {
                    navigate(data.path);
                    setShowDrawer(false);
                  }}
                  key={data.title}
                  title={isCollapsed ? _.startCase(data.title) : undefined}
                >
                  <ListItemIcon
                    collapsed={isCollapsed}
                    className={classes.iconContainer}
                  >
                    <Icon
                      src={
                        data.title === selectedItem ? data.icon : data.inactive
                      }
                    />
                  </ListItemIcon>

                  {!isCollapsed && (
                    <ListItemText selected={data.title === selectedItem}>
                      {_.startCase(data.title)}
                    </ListItemText>
                  )}
                </ListItem>

                {data.hasOwnProperty("listItems") && (
                  <Collapse in={true} timeout="auto" unmountOnExit>
                    <List
                      style={{
                        borderBottom: `solid 0.3px rgba(255, 255, 255, 0.12)`,
                        padding: isCollapsed ? "0 0 8px 0" : undefined,
                        backgroundColor: isCollapsed
                          ? "#ffffff"
                          : "transparent",
                      }}
                      component="div"
                      disablePadding
                    >
                      {data.listItems.map((li, index) =>
                        li.hide ? null : (
                          <ListItem
                            key={index}
                            button
                            className={`${
                              isCollapsed
                                ? classes.nestedCollapsed
                                : classes.nested
                            } ${
                              li.title === selectedSubItem
                                ? isCollapsed
                                  ? classes.activeNestedCollapsed
                                  : classes.activeNested
                                : classes.inactiveNested
                            }`}
                            onClick={() => {
                              navigate(li.path);
                              setShowDrawer(false);
                            }}
                            title={
                              isCollapsed ? _.startCase(li.title) : undefined
                            }
                          >
                            <ListItemIcon
                              collapsed={isCollapsed}
                              className={`${classes.iconContainer} ${
                                isCollapsed
                                  ? li.title === selectedSubItem
                                    ? classes.iconContainerCollapsedActive
                                    : classes.iconContainerCollapsedInactive
                                  : ""
                              }`}
                              style={{}}
                            >
                              <Icon
                                src={
                                  li.title === selectedSubItem
                                    ? li.icon
                                    : li.inactive
                                }
                              />
                            </ListItemIcon>
                            {!isCollapsed && (
                              <ListItemText
                                selected={li.title === selectedSubItem}
                              >
                                {_.startCase(li.title)}
                              </ListItemText>
                            )}
                          </ListItem>
                        ),
                      )}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ))}
        </List>
      </div>
    </Drawer>
  );
}

const ListItemText = styled.span`
  font-family: openSans-bold, sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${({ selected }) => (selected ? "#ffffff" : "#acb1c2")};
`;

const Icon = styled.img`
  object-fit: contain;
  width: 16px;
  height: 16px;
  color: #acb1c2;
`;

const ListItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${({ collapsed }) =>
    !collapsed &&
    `
      margin-right: 14px;
      width: auto;
    `}
`;
